<template>
  <div>
    <header class="game">
      <a style="cursor: pointer" @click.prevent="goToHomePage"  class="logo_score">
        <img :src="getTranslations.project_logo_img" alt="">
      </a>
      <div class="player_section">
      </div>
    </header>

    <div class="container-fluid">
      <div class="row score_page">
        <div class="iframe_section">
          <iframe src="static/penalty_kicks/index.html" frameborder="0"></iframe>
        </div>
      </div>
    </div>
    <component :is="currentModal" @close="closeModal()"></component>
  </div>
</template>

<script>
/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
/* postgame.html */
import { mapGetters, mapState } from 'vuex';
import FreePlayGuaranteedPrize from './modals/FreePlayGuaranteedPrize';
import FreePlayPointsWon from './modals/FreePlayPointsWon';
import FreeRegistrationPoints from './modals/FreeRegistrationPoints';

export default {
  name: 'game-free-play-add-on',
  data() {
    return {
      currentModal: null,
      gameId: null,
    };
  },
  created() {
    console.log('in AddOnGame created hook');
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage);
  },
  methods: {
    goToHomePage() {
      this.$router.push('/');
    },
    receiveMessage(event) {
      window.removeEventListener('message', this.receiveMessage);
      // route to net page // modal with these data from index.html (can include if user scored or no)
      console.log(event.data);
      if (event.data.ballIn) {
        if (this.freeTrialGuaranteedPrize) {
          this.currentModal = FreePlayGuaranteedPrize;
        }
        this.currentModal = FreePlayPointsWon;
      } else {
        this.currentModal = FreeRegistrationPoints;
      }
      this.showHideModal();
    },
    closeModal() {
      this.currentModal = null;
      this.$router.push('/');
    },
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        /* eslint-disable */
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          console.log('user has not leveled up, going to home page');
          this.closeModal();
        });
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'freeTrialGuaranteedPrize',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/GameFreePlayAddOn.vue